export default __webpack_public_path__ + "locales/el-GR/EmptyView.json?hash=fd04be199a29d9848aa4bacc35f28e7b";